/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-07-06 16:23:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-02-29 11:06:43
 */
// import common from './common';
import home from './home';
import teamManage from './teamManage';
import shopManageMenus from './shopManage';
import talentCRM from './talentCRM';
import cooperationProgress from './cooperationProgress';
import secondColonelManage from './secondColonelManage';
import sampleOrder from './sampleOrder';
import extenTecord from './extenTecord';
import ranking from './ranking';
import cooperativeShop from './cooperativeShop';
import settings from './settings';
import contentLibray from './contentLibray'

const menus = [
	...home,
	...ranking,
	...teamManage,
	...shopManageMenus,
	...sampleOrder,
	...extenTecord,
	...talentCRM,
	...secondColonelManage,
	...cooperationProgress,
	...contentLibray,
	...cooperativeShop,
	...settings,
];

export const personCenterRoute = {
	path: '/personal',
	component: null,
	name: '个人中心',
	redirect: '/personal/center',
	showBread: true,
	useTemplate: true,
	visible: false,
	id: 100,
	parentId: 0,
	children: [
		{
			path: 'center',
			component: '/personal/center',
			name: '个人中心',
			visible: true,
			useTemplate: true,
			showBread: true,
			parentId: 100,
			children: null,
		},
	],
};
export default menus;
